import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af20597c&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=af20597c&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=af20597c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af20597c",
  null
  
)

export default component.exports